import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        catchAllBox: {
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
        },
        centeredProgress: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
    };
});
